import React from 'react';
import { Settings as SettingsIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CollapsibleSection } from '../../../components/ui/CollapsibleSection';
import { SelectField } from '../../../components/ui/FormControls';

export const GeneralSettings = ({
    globalSettings,
    setGlobalSettings,
    isOpen,
    onToggle
}) => {
    const { t } = useTranslation();
    return (
        <CollapsibleSection
            id="general"
            title={t('settings.general.title')}
            description={t('settings.general.description')}
            icon={<SettingsIcon className="w-6 h-6" />}
            isOpen={isOpen}
            onToggle={onToggle}
        >
            <div className="max-w-xs">
                <SelectField
                    label={t('settings.general.landingPage')}
                    value={globalSettings.default_landing_page}
                    onChange={(val) => setGlobalSettings({ ...globalSettings, default_landing_page: val })}
                    help={t('settings.general.landingPageHelp')}
                    options={[
                        { value: 'dashboard', label: t('settings.general.optDashboard') },
                        { value: 'live', label: t('settings.general.optLiveView') },
                        { value: 'timeline', label: t('settings.general.optTimeline') }
                    ]}
                />

                <SelectField
                    label={t('settings.general.streamingMode')}
                    value={globalSettings.default_live_view_mode}
                    onChange={(val) => setGlobalSettings({ ...globalSettings, default_live_view_mode: val })}
                    help={t('settings.general.streamingModeHelp')}
                    options={[
                        { value: 'auto', label: t('settings.general.optAuto') },
                        { value: 'webcodecs', label: t('settings.general.optWebCodecs') },
                        { value: 'mjpeg', label: t('settings.general.optMjpeg') }
                    ]}
                />
            </div>
        </CollapsibleSection>
    );
};
